import { render } from "./CalendarioSimples.vue?vue&type=template&id=98550460&scoped=true"
import script from "./CalendarioSimples.vue?vue&type=script&lang=js"
export * from "./CalendarioSimples.vue?vue&type=script&lang=js"

import "./CalendarioSimples.vue?vue&type=style&index=0&id=98550460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98550460"]])

export default __exports__